import React from 'react';

// Renders one or more "Label: value" callouts in a single bordered strip.
// Used for the secondary insights under each Evidence grid (e.g. "Highest
// breach exposure", "Highest rework signal") so both tabs present these the
// same way instead of each inventing their own grid/spacing.

export default function InsightStrip({ items = [], style = null }) {
  const visible = items.filter(Boolean);
  if (!visible.length) return null;
  return (
    <div
      className="evidence-summary-strip"
      style={{
        display: 'grid',
        gridTemplateColumns: visible.length > 1 ? 'repeat(auto-fit, minmax(240px, 1fr))' : '1fr',
        gap: 10,
        ...(style || {}),
      }}
    >
      {visible.map((item, i) => (
        <div key={i}>
          <strong>{item.label}:</strong> {item.value}
        </div>
      ))}
    </div>
  );
}
